export default "__VITE_ASSET__CSciZhM7__"